import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import VContactForm from '../components/VContactForm.vue'
import VNewsletterSignUp from '../components/VNewsletterSignUp.vue'
import { app } from '../app'

createApp({
  components: {
    VContactForm,
    VNewsletterSignUp
  },
  extends: app,
  mixins: [errorMixin]
})
  .use(vuetify)
  .use(i18n)
  .mount('#app')
